interface RatingBadgeProps {
  rating: number;
  size?: "sm" | "md";
}

export default function RatingBadge({ rating, size = "md" }: RatingBadgeProps) {
  const sizeCls = size === "sm" ? "text-xs px-1.5 py-0.5" : "text-sm px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-accent-500 font-semibold text-background-50 ${sizeCls}`}
    >
      <i className="ri-star-fill text-[0.9em]" />
      {rating.toFixed(1)}
    </span>
  );
}